import {Injectable} from '@angular/core';
import {LoaderService} from '../../../services/loader.service';
import {GlobalErrorHandlerService} from '../../../services/global-error.service';
import {AttachmentService} from '../../../services/attachments.service';
import {DocumentsService} from '../../../services/document.service';
import {DocumentType, PatientDocument} from '../../../health/patient-profile/patient-dashboard/chart/document';
import {AlertService} from '../../../_alert';
import {PrintService} from '../../../services/print.service';

@Injectable({
  providedIn: 'root'
})
export class AssociateCarePlanWithChartService {
  public document: PatientDocument = new PatientDocument();
  public documentsType: DocumentType[];
  public successMessage = false;
  public statusMessage = '';

  constructor(public loaderService: LoaderService, public globalErrorHandlerService: GlobalErrorHandlerService,
              public attachmentService: AttachmentService, public alertService: AlertService,
              public documentsService: DocumentsService, public printService: PrintService) {
    this.getDocumentType();
  }
   getDocumentType() {
     this.documentsService.getDocumentsType().then(resp => {
       this.documentsType = resp.map(type => new DocumentType().load_from_json(type));
       console.log(this.documentsType)
     })
   }

  // Returns a promise that only resolves once the Document record exists and is linked to the
  // attachment, i.e. once the file is genuinely visible in the patient's Medical Chart. Callers
  // await this before showing success, so a failure partway through (e.g. the attachment upload
  // succeeding but the Document record failing to save) surfaces as an error instead of a false
  // "added to chart" state.
  associateToMedicalChart(params: any): Promise<any> {
    console.log('associateToMedicalChart method srvice')
    let el = params.template;
    return this.printService.renderToPdf(el.nativeElement).then((doc) => {
      let file = doc.output('blob', {filename: 'CarePlan.pdf'});
      this.statusMessage = 'Uploading Care Plan'
      //this.alertService.success('Uploading Care Plan..', this.alertService.options);
      return this.uploadAttachment(file, params);
    });
  }

  uploadAttachment(file: any, params: any): Promise<any> {
    this.statusMessage = this.statusMessage + '.'
    //this.alertService.success('Uploading Care Plan..', this.alertService.options);
    let attachment = { fileType: params.fileType, file: file, title: params.title, description: params.description,
      attachable_type: params.attachable_type, attachable_id: 0, doctor_id: params.doctor_id}
    if (attachment.file == undefined) {
      this.globalErrorHandlerService.error = 'Please select a valid file.';
      return Promise.reject('Please select a valid file.');
    }
    return new Promise((resolve, reject) => {
      let callback = (p: any): void => {
        console.log(p);
      };

      let upload_callback = (data: any) => {
        if (data !== '') {
          file = null;
          this.setDocumentAttributes(JSON.parse(data).id, params);
          this.attachDocumentWithMedicalChart().then(resp => {
            this.loaderService.hide();
            this.alertService.success('Successfully added to Medical Chart.', this.alertService.options);
            this.successMessage = true;
            this.statusMessage = '';

            setTimeout(() => {
              this.successMessage = false;
            }, 10000)
            resolve(resp);
          }).catch(err => {
            this.loaderService.hide();
            reject(err);
          });
        }
        else {
          file = null;
          this.loaderService.hide();
          reject('Upload failed');
        }
      };
      this.attachmentService.upload(attachment, callback, upload_callback);
    });
  }
  attachDocumentWithMedicalChart(): Promise<any> {
    this.statusMessage = this.statusMessage + '..'
    //this.alertService.success('Uploading Care Plan...', this.alertService.options);
    return this.documentsService.save(this.document).then(resp => {
      this.document.load_from_json(resp);
      return resp;
    }).catch((res: Response) => {
      this.globalErrorHandlerService.error = 'Failed to add document to Medical Chart.';
      this.loaderService.hide();
      throw res;
    });
  }

  setDocumentAttributes(attachment_id: any, params: any) {
    this.document.patient_id = params.patient_id;
    this.document.attachment_id = attachment_id;
    this.document.document_type_id = this.documentsType.filter(type => type.name == params.document_type)[0]['id'];
    if (params.doctor_id) {
      this.document.doctor_id = params.doctor_id;
    }
    this.document.date = params['date'] ? params['date'] : new Date().toString();
    this.document.name = params.title;
    if (params['sourceable_type']) {
      this.document.source_type = params['sourceable_type']
    }
    if (params['sourceable_id']) {
      this.document.source_id = params['sourceable_id']
    }
    return this.document
  }
}
